import React from "react";

import "./InfoPageHeader.scss";
import QuizzyClouds from "../QuizzyClouds/QuizzyClouds";

function InfoPageHeader(props) {
  function popBubble(event) {
    const svgElement = event.target;
    const bubbleDiv = svgElement.parentNode; // Target the parent div

    // Apply the animation to the parent div
    bubbleDiv.style.animation = "popBubble 0.5s forwards ease-out";

    // Remove the bubble div from the DOM after the animation is done
    setTimeout(() => {
      bubbleDiv.remove();
    }, 500); // 0.5s matches the animation duration
  }

  const renderTitle = React.isValidElement(props.title) ? (
    props.title
  ) : (
    <h1>{props.title}</h1>
  );

  const renderCaption = React.isValidElement(props.caption) ? (
    props.caption
  ) : (
    <p className="caption">{props.caption}</p>
  );

  const renderExtra =
    props.extra && React.isValidElement(props.extra) && props.extra;

  const renderTop = props.top && React.isValidElement(props.top) && props.top;
  return (
    <>
      <div className="info-page-header">
        <QuizzyClouds></QuizzyClouds>
        <div className="circle circle-1" onClick={popBubble}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            viewBox="0 0 64 64"
          >
            <circle
              id="Ellipse_634"
              data-name="Ellipse 634"
              cx="32"
              cy="32"
              r="32"
              fill="#c7b6f4"
            />
          </svg>
        </div>
        <div className="circle circle-2" onClick={popBubble}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="126"
            height="126"
            viewBox="0 0 126 126"
          >
            <circle
              id="Ellipse_633"
              data-name="Ellipse 633"
              cx="63"
              cy="63"
              r="63"
              fill="#a586ee"
            />
          </svg>
        </div>
        {renderTop}
        <p className="caption date-created">{props.top_text}</p>
        {renderTitle}
        {renderCaption}
        {renderExtra}
        {props.creator && (
          <div
            className="creator"
            onClick={() => {
              window.location.href = "/users/" + props?.creator?.userid + "/";
            }}
          >
            <img src={props?.creator?.image} alt="Avatar"></img>
            <div className="creator-info">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "5px",
                  marginTop: "2px",
                }}
              >
                <p className="creator-username">{props?.creator?.username}</p>
                {props?.creator?.verified && (
                  <img
                    src="/images/user/check.svg"
                    className="checkmark"
                    title="This user is verified."
                    alt="checkmark icon"
                  />
                )}
              </div>
              <p className="created">{props?.date_created}</p>
            </div>
          </div>
        )}

        {props.cta}
      </div>
    </>
  );
}

export default InfoPageHeader;
